import React, { useState } from 'react'
import { Card, CardTitle, CardText,CardBody, CardSubtitle, Modal, ModalBody, Button } from 'reactstrap';
import { Link } from "react-router-dom";
import API from '../../API';
import axios from 'axios';
const CardSecondary = ({
    projectName,
    projectCategory,
    projectImage,
    projectDate,
    NoImage,
    projectLinks,
    project_status,
    status,
    lead_purchased,
    noShowLeadCard,
    bookmark,
    project_id,
    onArchive,
    onUnarchive
}) => {
    const getStatusOfSTatus = (status,lead_purchased) => {
        if (status === 2 && !lead_purchased) {
            return 'Lead available'
        } 
        else if (status === 2 && lead_purchased) {
            return 'Bid Now'
        } else if (status === 3) {
            return 'Hired'
        } else if (status === 4) {
            return 'Completed'
        } else if (status === 9) {
            return 'Cancelled'
        } else if (status === 6) {
            return "Cancellation Requested"
        }
    }
    const [bookmarked, setbookmarked] = useState(bookmark)
    const [showArchiveModal, setShowArchiveModal] = useState(false)
    const isArchiveMode = typeof onArchive === "function";
    const isUnarchiveMode = typeof onUnarchive === "function";
    const statusLabel = getStatusOfSTatus(project_status, lead_purchased);
    
    const bookmarkThis = (bookmarked, id) => {
        const apiUrl = API.baseURL + `/v2/providers/projects/${id}/bookmark`;
        setbookmarked(!bookmark)
        if (bookmarked) {
            axios.delete(apiUrl,{}, API.options).then((res)=>{
                console.log(res);
                
            }).catch((err)=>{
                console.log(err);
            })
        } else {
            axios.post(apiUrl, {}, API.options).then((res)=>{
                console.log(res);
                
            }).catch((err)=>{
                console.log(err);
            })
            
        }
    }
    
    const toggleArchiveModal = () => {
        setShowArchiveModal(!showArchiveModal);
    }
    
    const handleArchiveConfirm = () => {
        const apiUrl = API.baseURL + `/v2/providers/projects/${project_id}/hidden_lead`;
        axios.post(apiUrl, {}, API.options).then((res) => {
            console.log('Project archived successfully:', res);
            toggleArchiveModal();
            if (onArchive) {
                onArchive();
            }
        }).catch((err) => {
            console.error('Error archiving project:', err);
            toggleArchiveModal();
        });
    }

    const handleUnarchiveConfirm = () => {
        const apiUrl = API.baseURL + `/v2/providers/projects/${project_id}/hidden_lead`;
        axios.delete(apiUrl, API.options).then((res) => {
            console.log('Project unarchived successfully:', res);
            toggleArchiveModal();
            if (onUnarchive) {
                onUnarchive();
            }
        }).catch((err) => {
            console.error('Error unarchiving project:', err);
            toggleArchiveModal();
        });
    }
    return (
        <div className="ebw-card__wrap ebw-card__wrap--secondary">
            <Card className="ebw-card ebw-card__secondary">
                {(isArchiveMode || isUnarchiveMode) && (
                    <div className="es-card__batch" style={{position: 'absolute',right: 10,top:10,zIndex:9, backgroundColor: 'white', borderRadius: '50%', padding: '5px'}}>
                        <svg 
                            style={{width:20, height:20, cursor: 'pointer'}} 
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                toggleArchiveModal();
                            }} 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            {isUnarchiveMode ? (
                                <path 
                                    d="M3 7V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V7M3 7H21M3 7L4 19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19L21 7M12 9V15M9 12H15" 
                                    stroke="#666" 
                                    strokeWidth="2" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                />
                            ) : (
                                <path 
                                    d="M3 7V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V7M3 7H21M3 7L4 19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19L21 7M9 12H15" 
                                    stroke="#666" 
                                    strokeWidth="2" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                />
                            )}
                        </svg>
                    </div>
                )}
                <Link className="w-100" to={projectLinks}>
                <div className="ebw-card__image-wrap">
                        {projectImage && (
                            <div style={{ backgroundImage: `url(${projectImage})` }} className="ebw-card__image-inwrap">
                            </div>
                        )}
                        {!projectImage && (
                            <div className="ebw-card__image-inwrap" style={{backgroundColor: '#3a4ee8',backgroundSize:'contain', backgroundImage: `url(/images/logo-trans.svg)` }}>
                            </div>
                        )} 
                    </div>
                    <CardBody className={` ${status ? "d-flex flex-column justify-content-between ebw-card__body-status" : "ebw-card__secondary-body"}`}>
                        <div>
                            <div className="d-flex justify-content-between">
                                <div className="ebw-card__secondary-titles">
                                    <CardTitle className="ebw-card__secondary-title">{projectName}</CardTitle>
                                    <CardSubtitle className="ebw-card__subtitle mb-0">{projectCategory?.title}</CardSubtitle>
                                </div>
                                <div className="text-right">
                                    {!noShowLeadCard && statusLabel && (
                                        <div className="ebw-card__label">{statusLabel}</div>
                                    )}
                                    <CardText className="ebw-card__date">{projectDate}</CardText>
                                </div>
                            </div>
                            
                        </div>
                    </CardBody>
                </Link>
            </Card>
            <Modal isOpen={showArchiveModal} toggle={toggleArchiveModal} className="ebw-global__modal">
                <div className="ebw-modal__wrap ebw-modal__wrap--danger pb-0">
                    <ModalBody className="ebw-global__modal-body text-center">
                        <h3 className="text-lg mb-2">
                            {isUnarchiveMode
                                ? "Are you sure you want to unarchive this project?"
                                : "Are you sure you want to hide this project?"}
                        </h3>
                        <p className="text-sm mb-5">
                            {isUnarchiveMode
                                ? "This project will be restored and visible in your activities."
                                : "You will no longer be able to see this project again."}
                        </p>

                        <div className="d-flex justify-content-center">
                            <div className="col-4">
                                <Button className="ebw-button ebw-button__primary--grey" color="grey" type="button" onClick={toggleArchiveModal}>Cancel</Button>
                            </div>
                            <div className="col-4">
                                <Button
                                    className="ebw-button ebw-button__primary"
                                    style={{backgroundColor:'#2196f3'}}
                                    color="primary"
                                    type="submit"
                                    onClick={isUnarchiveMode ? handleUnarchiveConfirm : handleArchiveConfirm}
                                >
                                    Confirm
                                </Button>
                            </div>
                        </div>
                    </ModalBody>
                </div>
            </Modal>
        </div>
        
    );
}

export default CardSecondary
